<template>
  <div class="periodo-wrapper-inner">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="fechas"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="field">
          <label class="field-label">Periodo</label>
          <v-text-field
            v-model="fechasTexto"
            readonly
            outlined
            dense
            hide-details="auto"
            prepend-inner-icon="mdi-calendar-range"
            placeholder="Selecciona un periodo"
            v-bind="attrs"
            v-on="on"
            class="dark-input"
          ></v-text-field>
        </div>
      </template>
      <v-date-picker
        v-model="fechas"
        range
        no-title
        scrollable
        :first-day-of-week="1"
        locale="es-mx"
        class="dark-picker"
      >
        <v-spacer></v-spacer>
        <button class="btn-ghost" @click="menu = false">Cancelar</button>
        <button class="btn-primary" @click="buscar">Buscar</button>
      </v-date-picker>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: "PeriodoBusqueda",

  data: () => ({
    fechas: [],
    menu: false,
  }),

  computed: {
    fechasTexto() {
      return this.fechas.join(' – ');
    }
  },

  methods: {
    buscar() {
      this.$emit("buscar", this.fechas)
      this.menu = false
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.periodo-wrapper-inner {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --radius: 4px;

  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-family: var(--font-body);
  max-width: 320px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 8px 16px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover {
  filter: brightness(1.08);
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 8px 14px;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  margin-right: 8px;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

/* ===== Overrides v-text-field ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 13.5px !important;
  cursor: pointer;
}

.dark-input >>> .v-icon {
  color: var(--text-tertiary) !important;
}

/* ===== Overrides v-date-picker (range) ===== */
.periodo-wrapper-inner >>> .v-picker {
  background: var(--card) !important;
}

.periodo-wrapper-inner >>> .v-date-picker-header,
.periodo-wrapper-inner >>> .v-picker__body,
.periodo-wrapper-inner >>> .v-date-picker-table {
  background: var(--card) !important;
}

.periodo-wrapper-inner >>> .v-date-picker-header button,
.periodo-wrapper-inner >>> .v-date-picker-header .v-icon,
.periodo-wrapper-inner >>> .v-date-picker-table th {
  color: var(--text-primary) !important;
}

.periodo-wrapper-inner >>> .v-date-picker-table .v-btn {
  color: var(--text-secondary) !important;
}

.periodo-wrapper-inner >>> .v-date-picker-table .v-btn.v-btn--active {
  background: var(--accent) !important;
  color: var(--bg) !important;
}

.periodo-wrapper-inner >>> .v-picker__actions {
  background: var(--card) !important;
  padding: 10px 12px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialogos/PeriodoBusqueda.vue